require('./bootstrap');

import Masonry from 'masonry-layout';
import Swiper, {Autoplay, Navigation, Pagination} from 'swiper';

Swiper.use([Navigation, Pagination, Autoplay]);

if (document.querySelector('.grid')) {
    new Masonry('.grid', {
        columnWidth: '.grid-sizer',
        gutter: '.gutter-sizer',
        itemSelector: '.grid-item',
        percentPosition: true,
        resize: true
    });
}

if (document.querySelector('.swiper')) {
    new Swiper('.swiper', {
        loop: true,
        autoplay: {
            delay: 3500,
            disableOnInteraction: false,
        },
        pagination: {
            el: '.swiper-pagination',
            clickable: true,
        },
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        }
    });
}
